import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminInvitationsPanel } from '../components/AdminInvitationsPanel';
import { SESSION_TOKEN } from '../lib/session';

// Admin invitations route (arc 101 slice 01). Thin: <AdminGate/> keeps the
// panel (and its `/v1/admin/invitations` reads + revoke/resend writes) behind
// the closed-beta staff wall. `token` is injectable for tests; the router
// mounts with no props.

export function AdminInvitations(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  return (
    <AdminGate token={token}>
      <AdminInvitationsPanel token={token} />
    </AdminGate>
  );
}
